import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { ENVIRONMENT_SETTINGS, type EnvironmentSettings } from '@reconcept-platform/env';
import {
  AUTH_API_URL,
  AUTH_APP_ID,
  AUTH_APP_URL,
  AUTH_REDIRECT_SOURCE,
  AUTH_REDIRECT_URI,
  AUTH_SCOPE,
  BE_API_URL,
} from './shared-authentication.types';

export function getGraphqlUrlFactory() {
  return inject(ENVIRONMENT_SETTINGS).portfolioApiURL;
}

export function getAuthApiUrlFactory() {
  return inject(ENVIRONMENT_SETTINGS).authApiURL;
}

export function getAuthAppUrlFactory() {
  return inject(ENVIRONMENT_SETTINGS).authAppURL;
}

export function provideAuthTokensFromEnv() {
  return [
    {
      provide: AUTH_APP_ID,
      useFactory: (envSettings: EnvironmentSettings) => envSettings.authAppId,
      deps: [ENVIRONMENT_SETTINGS],
    },

    {
      provide: AUTH_REDIRECT_SOURCE,
      useFactory: (envSettings: EnvironmentSettings) => envSettings.authRedirectSource,
      deps: [ENVIRONMENT_SETTINGS],
    },
    {
      provide: AUTH_SCOPE,
      useFactory: (envSettings: EnvironmentSettings) => envSettings.authScope,
      deps: [ENVIRONMENT_SETTINGS],
    },
    {
      provide: AUTH_REDIRECT_URI,
      useFactory: (envSettings: EnvironmentSettings) => envSettings.authRedirectURI,
      deps: [ENVIRONMENT_SETTINGS],
    },
    {
      provide: AUTH_API_URL,
      useFactory: (envSettings: EnvironmentSettings) =>
        envSettings.canChangeBE ? envSettings.authApiURL : getAuthApiUrlFactory(),
      deps: [ENVIRONMENT_SETTINGS],
    },
    {
      provide: AUTH_APP_URL,
      useFactory: (envSettings: EnvironmentSettings) =>
        envSettings.canChangeBE ? envSettings.authAppURL : getAuthAppUrlFactory(),
      deps: [ENVIRONMENT_SETTINGS],
    },
    {
      provide: BE_API_URL,
      useFactory: (envSettings: EnvironmentSettings) =>
        envSettings.canChangeBE ? envSettings.portfolioApiURL : getGraphqlUrlFactory(),
      deps: [ENVIRONMENT_SETTINGS],
    },
  ];
}

@NgModule({
  imports: [CommonModule],
})
export class SharedAuthenticationModule {}
